import Vue from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/it'
import { formatDate, parseDate } from '@/utils/date_manipulation'

// dayjs configuration
dayjs.locale('it')
dayjs.extend(require('dayjs/plugin/customParseFormat'))
dayjs.extend(require('dayjs/plugin/isBetween'))
dayjs.extend(require('dayjs/plugin/relativeTime'))
dayjs.extend(require('dayjs/plugin/objectSupport'))
dayjs.extend(require('dayjs/plugin/duration'))

// dayjs is accessible in components with 'this.$date'
Vue.prototype.$date = dayjs
Vue.prototype.$date.prototype = dayjs.prototype

// Filters for views
Vue.filter('format_date', (date, outputFormat, inputFormat) => {
  return formatDate({ date: date, outputFormat, inputFormat })
})

Vue.filter('time_from_now', (date, format = 'YYYY-MM-DD', suffix = true) => {
  return parseDate({ date, inputFormat: format }).fromNow(suffix)
})